import React from 'react';
import { RichText } from '../../../helpers/richText';
import styles from './extras.scss';
import classNames from 'classnames';
import { IProductFeatureInExtras, IRichTextItemsInternal } from '../../../stores/pdpTypes';

export default class Extras extends React.Component<IExtras,
    { debuggerIsOn: boolean; extras: IProductFeatureInExtras[];
        injectedRichText?: IRichTextItemsInternal[]; }> {

    constructor(props) {
        super(props);

        this.state = {
            debuggerIsOn: this.props.debuggerIsOn,
            extras: this.props.extras,
            injectedRichText: this.props.injectedRichText,
        };


        this.turnOnDebugger = this.turnOnDebugger.bind(this);
    }

    public turnOnDebugger(value: boolean): void {
        this.setState({debuggerIsOn: value});
    }

    public updateExtras(extras: IProductFeatureInExtras[]): void {
        this.setState({ extras: extras });
    }

    public render() {
        return (
            <div>
                {this.state.extras.map(module => {
                    return (
                        <div key={module.title} className={styles.text_module}>
                            <div className={styles.title} dangerouslySetInnerHTML={{ __html: module.title }} />
                            <div className={styles.tm_container}>
                                {(module.rtfText && module.rtfText.length > 0) &&
                                    <div className={classNames(styles.text)}
                                        dangerouslySetInnerHTML={{ __html: module.rtfText }} />
                                }
                                {(module.structuredText && module.structuredText.id) &&
                                    <div className={classNames(styles.text)}>
                                        <RichText richTextId={module.structuredText.id}
                                            injectedRichTexts={this.props.injectedRichText}/>
                                    </div>
                                }
                                {module.image && (
                                    <img
                                        onLoad={() => {this.props.updateProductInfoContentHeight(true)}}
                                        src={module.image.imageUrl}
                                        className={styles.tm_image}
                                        alt={module.image.altText}
                                    />
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

interface IExtras {
    extras: IProductFeatureInExtras[];
    debuggerIsOn: boolean;
    updateProductInfoContentHeight(recalculateClientHeight: boolean);
    injectedRichText?: IRichTextItemsInternal[];
}
